import React from 'react';
import SideBar from '../layout/SideBar';

const LayoutWrapper = ({ children }) => {
  return (
    <SideBar>
      {children}
    </SideBar>
  );
};

export default LayoutWrapper;
